export default __webpack_public_path__ + "static/media/Samatar_Xasan_Resume.77cfc2f9.pdf";